import styles from "./Header.module.scss";
import logo from "../../../assets/image/DownloadPage/LogoText.png";

const Header = () => {
  return (
    <div className={styles.header}>
      <img src={logo} alt="logo" className={styles.logo} />
    </div>
  );
};

export default Header;
